module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 5px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "padding": "0px !important",
      "display": "flex",
      "align-items": "stretch"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary dropdown-toggle",
    staticStyle: {
      "width": "100%",
      "justify-content": "space-between",
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "id": 'dropdown_' + _vm.id
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.label.length > 12 ? _vm.label.substring(0, 12) + "..." : _vm.label))]), _vm._v(" "), (_vm.multiple && Array.isArray(_vm.selected) && _vm.selected.length > 1) ? _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(" + _vm._s(_vm.selected.length) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "auto",
      "width": "100%",
      "max-height": "250px",
      "height": "auto",
      "padding": "2px 0px !important",
      "top": "auto",
      "border-radius": "4px"
    },
    attrs: {
      "aria-labelledby": 'dropdown_' + _vm.id
    }
  }, [(_vm.multiple) ? _c('ul', _vm._l((_vm.mappedOptions), function(option) {
    return _c('li', {
      key: option.id,
      staticClass: "checkbox-custom checkbox-primary dropdown-item",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.checked),
        expression: "option.checked"
      }],
      attrs: {
        "name": 'checkbox_' + option.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": option.checked,
        "checked": Array.isArray(option.checked) ? _vm._i(option.checked, null) > -1 : (option.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = option.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(option, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(option, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(option, "checked", $$c)
          }
        }, function($event) {
          _vm.toggleMultipleElem(option)
        }]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "elem-item-name"
    }, [_c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(option.name) + " ")])])])
  })) : _c('ul', _vm._l((_vm.mappedOptions), function(option) {
    return _c('li', {
      key: option.id,
      staticClass: "dropdown-item",
      style: (("text-align: left;cursor: pointer; " + (option.id === _vm.selected ? 'background-color: #eee' : ''))),
      on: {
        "click": function($event) {
          _vm.selected = option.id
        }
      }
    }, [_c('label', {
      staticClass: "elem-item-name",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [(option.icon) ? _c('span', {
      style: ('color:' + option.iconColor)
    }, [_vm._v(_vm._s(option.icon))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(option.name) + " ")])])])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61e0257a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/superconciergerie/components/DropdownSelector.vue
// module id = 1405
// module chunks = 0